import React, { Component, PropTypes } from 'react'
import $ from 'jquery'

class Parallax extends Component {

  componentDidMount() {
    $(document).ready(() => {
      $('.parallax').parallax()
    });
  }

  render() {
    const { image, alt, title } = this.props
    if (title) {
      return (
        <div className="parallax-container">
          <div className="parallax valign-wrapper">
            <img src={`images/background/${image}.jpg`} alt={alt}/>
          </div>
          <div className="valign">
            <span className="white"><h1 className="center-align page-title">{title}</h1></span>
          </div>
        </div>
      )

    }
    else {
      return (
        <div className="parallax-container">
          <div className="parallax valign-wrapper">
            <img src={`images/background/${image}.jpg`} alt={alt}/>
          </div>
        </div>
      )
    }
  }

}

const { string } = PropTypes
Parallax.propTypes = {
  image: string.isRequired,
  alt: string.isRequired,
  title: string
}

export default Parallax



/** WEBPACK FOOTER **
 ** ./src/components/Parallax.js
 **/